import React from 'react'
import { cn } from '../../utils/cn'

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Variant for skeleton shape
   */
  variant?: 'text' | 'rectangular' | 'circular' | 'rounded'

  /**
   * Width of skeleton (can be string or number)
   */
  width?: string | number

  /**
   * Height of skeleton (can be string or number)
   */
  height?: string | number

  /**
   * Animation type
   */
  animation?: 'pulse' | 'none'
}

const skeletonVariants = {
  variant: {
    text: 'rounded h-4',
    rectangular: '',
    circular: 'rounded-full',
    rounded: 'rounded-lg',
  },
  animation: {
    pulse: 'animate-pulse',
    none: '',
  },
}

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  (
    {
      className,
      variant = 'rectangular',
      width,
      height,
      animation = 'pulse',
      ...props
    },
    ref
  ) => {
    const styles: React.CSSProperties = {}

    if (width !== undefined) {
      styles.width = typeof width === 'number' ? `${width}px` : width
    }

    if (height !== undefined) {
      styles.height = typeof height === 'number' ? `${height}px` : height
    }

    return (
      <div
        ref={ref}
        style={styles}
        className={cn(
          // Base styles
          'bg-gray-200',

          // Variant styles
          skeletonVariants.variant[variant],

          // Animation
          skeletonVariants.animation[animation],

          // Custom className
          className
        )}
        {...props}
      />
    )
  }
)

Skeleton.displayName = 'Skeleton'

export default Skeleton
